// extracted by mini-css-extract-plugin
export default {"logo":"_9d0159a7"};